import React from "react";
import { Link } from "react-router-dom";

export default function PageError404() {
  return (
    <div className="gd-status-page">
      <div className="gd-status-card">
        <span className="gd-status-code">404</span>
        <h1>Página no encontrada</h1>
        <p>La dirección no existe o el enlace ya no está disponible.</p>
        <Link className="gd-btn gd-btn-primary" to="/">
          Ir al inicio
        </Link>
      </div>
    </div>
  );
}
